<template>
	<div class="cents">
		<van-nav-bar title="人脸管理" left-arrow safe-area-inset-top style="background-color: #1ABC9C;"
			@click-left="goto" />
		<div class="requist">
			<van-field :border="true" clearable size="large" v-model="keyword" placeholder="设备名或者位置" />
			<van-button color="#1ABC9C" size="small" @click='questlist'>查询</van-button>
		</div>
		<van-list
		    v-model="loading"
		    :finished="finished"
		    :finished-text="$t('mygd')"
			:loading-text="$t('加载中')"
		    @load="loadMore"
		>
			<div v-for="item in faceList" :key="item.id" class="personItem">
				<img v-if="item.face_url" :src="headerImgUrl+item.face_url" class="itemImg" />
				<img v-else src="../../images/selectfile.png" class="itemImg" />
				<div class="itemInfoBox">
					<div class="itemInfo">
						<div class="itemName">{{item.name}}</div>
						<div class="itemMobile" v-if="item.mobile">({{item.mobile}})</div>
					</div>
					<div class="itemInfo">
						<div class="itemDept">部门：{{item.dept_name}}</div>
					</div>
					<div style="text-align: left;" v-if="item.card_no">卡号：{{item.card_no}}</div>
				</div>
				<div class="itemBtn" @click="handleDle(item.user_id,item.has_key)">{{item.has_key?'删除':'增加'}}</div>
			</div>
		</van-list>
		<!-- 删除弹窗 -->
		<popup :title='delPopTile' :popState='delPopState' @popClose='delPopClose' @popConfirm='delPopConfirm'></popup>
	</div>
</template>

<script>
	import popup from '@/components/popupInput.vue'
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				headerImgUrl: "https://web.fondcard.net/static",
				UserInfo: JSON.parse(window.localStorage.getItem("getTokendata")), // 本地缓存 获取用户数据
				keyword: '', // 搜索框 绑定值
				faceList: [], // 列表数据
				delPopTile: '人脸删除', // 删除 弹窗 title
				delPopState: false, // 删除 弹窗 状态
				personId: '', // 点击人员的 id
				loading:false,
				finished: false,
				page_index:1,
				count:null,
			}
		},
		components: {
			popup
		},
		watch:{
			keyword(newVal){
				if(newVal==''){
					this.faceList = []
					this.finished = false;
					this.page_index = 1
					this.getList()
				}
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			// 获取更多列表
			loadMore() {
			    this.page_index++;
			    this.getList()
			},
			// 删除人脸 接口方法
			delFace(name,password) {
				let data = {
					method: 'co.wx.face.del',
					user_id: this.personId,
					name: name,
					password: this.$md5(password),
					device_id: this.$route.query.deviceId,
					login_user_id: this.UserInfo.user_id
				}
				this.$serve(data).then(res=>{
					if (res.data.code == 0) {
						Toast.success('人脸删除成功')
						this.page_index=1
						this.faceList = []
						this.finished = false;
						this.getList()
						this.delPopState=false
					} else if (res.data.code == -3) {
						Toast.fail('登录用户名不存在或密码错误')
					} else if (res.data.code == -5) {
						Toast.fail('操作失败')
					}
				})
			},
			// 增加人脸 接口 方法
			addFace() {
				let data = {
					method: 'co.wx.face.add',
					user_id: this.personId,
					agent_id: this.UserInfo.agent_id,
					device_id: this.$route.query.deviceId
				}
				this.$serve(data).then(res => {
					if (res.data.code == 0) {
						Toast.success('人脸增加成功')
						this.page_index=1
						this.faceList = []
						this.finished = false;
						this.getList()
					} else if (res.data.code == -3) {
						Toast.fail('用户ID不存在')
					} else if (res.data.code == -5) {
						Toast.fail('操作失败')
					} else if (res.data.code == -23) {
						Toast.fail('请在后台先注册人脸')
					}
				})
			},
			// 删除弹窗 确认按钮
			delPopConfirm(e) {
				if (e[0] == '') {
					Toast.fail('请输入用户名')
				} else if (e[1] == '') {
					Toast.fail('请输入密码')
				} else {
					this.delFace(e[0], e[1])
				}
			},
			// 关闭删除弹窗
			delPopClose() {
				this.delPopState = false
			},
			// 关闭增加弹窗
			addPopClose() {
				this.addPopState = false
			},
			// 点击按钮 删除/增加
			handleDle(id, has_key) {
				console.log(id, has_key);
				this.personId = id
				if (has_key == 0) { // 增加
					this.addFace()
				} else { // 删除
					this.delPopState = true
				}
			},
			// 获取列表数据 接口
			getList() {
				let data = {
					method: 'co.wx.face.list',
					agent_id: this.UserInfo.agent_id,
					page_index: this.page_index,
					page_size: 10,
					name: this.keyword,
					device_id: this.$route.query.deviceId,
					login_user_id: this.UserInfo.user_id
				}
				this.$serve(data).then(res => {
					// this.faceList = res.data.data
					this.loading = false;
					this.count = res.data.count
					if (res.data.data.length==0 || this.count === 0) {
					    // 加载结束
					    this.finished = true;
					    return;
					}
					this.faceList = this.faceList.concat(res.data.data)
					
					if (this.faceList.length >= this.count) {
					    this.finished = true;
					}
				})
			},
			// 点击查询
			questlist() {
				this.page_index=1
				this.faceList = []
				this.getList()
			},
			// 返回上一页
			goto() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped>
	.personItem {
		display: flex;
		border-bottom: 1px solid #ccc;
		padding: 10px 0;
	}

	.itemImg {
		width: 65px;
		height: 65px;
		border-radius: 50%;
		margin: 0 20px 0 10px;
	}

	.itemInfoBox {
		/* padding-top: 10px; */
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}

	.itemInfo {
		font-size: 15px;
		display: flex;
		width: 200px;
	}

	.itemName {
		flex: 3;
		display: flex;
		justify-content: flex-start;
	}

	.itemMobile {
		flex: 7;
		display: flex;
		justify-content: flex-start;
	}

	.itemBtn {
		background-color: #1ABC9C;
		width: 60px;
		height: 35px;
		color: #fff;
		border-radius: 5px;
		line-height: 35px;
		text-align: center;
		margin: auto;
		font-size: 14px;
	}

	.requist {
		width: 80%;
		margin: 0 auto;
		margin-top: 30px;
		margin-bottom: 30px;
		display: flex;
		justify-content: space-around;
	}

	.requist>>>.van-cell {
		width: 180px;
		border: 1px solid #ccc;
		padding: 4px 6px;
		border-radius: 4px;
	}

	.cents>>>.van-nav-bar__title {
		color: #fff;
	}

	.cents>>>.van-nav-bar .van-icon {
		color: #fff;
	}
</style>
